import React from "react"
import PropTypes from "prop-types"

class LanguageFilter extends React.Component {

  constructor(props) {
    super(props)

    this.state = {

    }

    this.descriptionText = this.descriptionText.bind(this)
    this.languageChoices = this.languageChoices.bind(this)
    this.nativeLanguageText = this.nativeLanguageText.bind(this)
  }

  nativeLanguageText() {
    let text = "Find people who are learning "
    let length = this.props.nativeLanguages.length
    return this.props.nativeLanguages.map((language, index) => {
        if(index == 0) {
          text += `${language.language.native}`
        } else if (index == length-1) {
          text += ` or ${language.language.native}, and their native language is:`
        } else {
          text +=  `, ${language.language.native}`
        }
        if(index === length-1) {
          return text
        }
    })
  }

  descriptionText() {
    if(this.props.nativeLanguages.length === 1 ) {
      return `Find people who are learning ${this.props.nativeLanguages[0].language.native}, and their native language is:`
    } else if (this.props.nativeLanguages.length > 1) {
      return this.nativeLanguageText()
    }
    return "Find people who are learning your native language, and their native language is:"
  }

  languageChoices() {
    return this.props.learningLanguages.map((language, index) => {
        return (
          <div key={index} style={{display: 'flex', flexDirection: 'row', marginTop: 15, marginBottom: 15, minWidth: 150}}>
            <input type="radio" checked={this.props.filters.language_ids.includes(language.language_id)} readOnly onClick={() => this.props.updateLanguageIds(language.language_id)}/>
            <h4 style={{paddingLeft: 10, color: '#01579b'}}>{language.language.native}</h4>
          </div>)
    })
  }

  render() {
    return(
      <div className="filterSection">
        <div>
          <h4 className="sectionHeader">Language(s)</h4>
          <h4 className="greyText" style={{paddingTop: 10}}>{this.descriptionText()}</h4>
        </div>
        <div style={{display: 'flex', flexDirection: (this.props.learningLanguages.length > 2 ? 'row' : 'column'), flexWrap: 'wrap'}}>
          {this.languageChoices()}
        </div>

      </div>
    )
  }
}


export default LanguageFilter;
